// Nav Menu JS
const { feather } = window;
let { $ } = window;

if (parseInt($().jquery, 10) < 3) {
  $ = require('jquery');
}

$(() => {
  $('header .sub-menu-toggle').on('click focusout', function callback(e) {
    e.preventDefault();

    const $this = $(this);
    const $chevronContainer = $this.find('.chevron-container');

    if (e.type === 'click') {
      $this.next().slideToggle(function complete() {
        const $el = $(this);
        if ($el.is('form')) {
          $el.find('input').first().focus();
          $('.menu').animate({ scrollTop: $el.offset().top });
        }
      });

      if ($chevronContainer.find('svg').hasClass('feather-chevron-down')) {
        $chevronContainer.html(feather.icons['chevron-up'].toSvg());
      } else {
        $chevronContainer.html(feather.icons['chevron-down'].toSvg());
      }
    } else {
      setTimeout(() => {
        $this.next().slideUp();
        $chevronContainer.html(feather.icons['chevron-down'].toSvg());
      }, 100);
    }
  });

  $('#mobile-nav-trigger').on('click', function callback() {
    const $this = $(this);
    const $icon = $this.find('svg');
    $('header.header').toggleClass('open');
    $('body').toggleClass('scroll-locked');
    if ($icon.hasClass('feather-menu')) {
      $icon.replaceWith(feather.icons.x.toSvg());
    } else {
      $icon.replaceWith(feather.icons.menu.toSvg());
    }
  });

  const headerEl = $('header.header')[0];

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.intersectionRatio < 1) {
        headerEl.classList.remove('scrolled');
        // $('body').removeClass('scrolled');
      } else {
        headerEl.classList.add('scrolled');
        // $('body').addClass('scrolled');
      }
    },
    {
      root: document.querySelector('body'),
      rootMargin: `-${($('#fixed-adder').height() + 10)}px 0px 0px 0px`,
      threshold: 1,
    },
  );

  if (headerEl) {
    observer.observe($('#fixed-adder')[0]);
  }

  $('#desktop-search-trigger').on('click', function callback(e) {
    if ($(window).width() >= 992) {
      $(this)
        .find('a')
        .addClass('active');
      e.preventDefault();
      $('.desktop-search-bar')
        .slideDown()
        .find('input')
        .focus();
    }
  });

  $('#desktop-search-close').on('click', () => {
    if ($(window).width() >= 992) {
      $('#desktop-search-trigger')
        .find('a')
        .removeClass('active');
      $('.desktop-search-bar').slideUp();
    }
  });

  $('#desktop-login-trigger').on('click', function callback(e) {
    $(this)
      .find('a')
      .addClass('active');
    e.preventDefault();
    $('.modal-overlay')
      .fadeIn()
      .find('input')
      .first()
      .focus();

    $('body').addClass('scroll-locked');
  });

  const closeLoginModal = () => {
    $('#desktop-login-trigger')
      .find('a')
      .removeClass('active');
    $('.modal-overlay').fadeOut();
    $('body').removeClass('scroll-locked');
  };

  $('#desktop-login-close').on('click', () => {
    closeLoginModal();
  });

  $('.modal-overlay').on('click', (e) => {
    if ($(e.target).hasClass('modal-overlay')) {
      closeLoginModal();
    }
  });
});
